import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import qrCode from '../assets/image copy.png';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
`;

const pulse = keyframes`
  0%, 100% { box-shadow: 0 0 0 0 rgba(95, 37, 159, 0.4); }
  50% { box-shadow: 0 0 0 14px rgba(95, 37, 159, 0); }
`;

const Page = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  font-family: 'Inter', -apple-system, sans-serif;
`;

const Card = styled.div`
  background: rgba(255,255,255,0.05);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 24px;
  padding: 40px 36px;
  max-width: 420px;
  width: 100%;
  text-align: center;
  animation: ${fadeIn} 0.5s ease;

  @media (max-width: 480px) {
    padding: 28px 20px;
  }
`;

const Logo = styled.div`
  margin-bottom: 6px;
  h1 { font-size: 20px; font-weight: 800; color: #fff; }
  p { font-size: 11px; color: rgba(255,255,255,0.3); font-style: italic; }
`;

const Title = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  margin: 20px 0 6px;
`;

const Sub = styled.p`
  font-size: 13px;
  color: rgba(255,255,255,0.5);
  margin-bottom: 24px;
`;

const FeeBox = styled.div`
  background: linear-gradient(135deg, rgba(95,37,159,0.4), rgba(109,40,217,0.25));
  border: 1px solid rgba(95,37,159,0.5);
  border-radius: 14px;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 28px;
`;

const FeeLabel = styled.span`
  font-size: 13px;
  color: rgba(255,255,255,0.6);
`;

const FeeAmount = styled.span`
  font-size: 28px;
  font-weight: 800;
  color: #e9d5ff;
`;

const QRWrapper = styled.div`
  background: #fff;
  border-radius: 20px;
  padding: 18px;
  display: inline-block;
  margin-bottom: 24px;
  animation: ${pulse} 2.5s infinite;
`;

const QRImage = styled.img`
  width: 210px;
  height: 210px;
  display: block;

  @media (max-width: 480px) {
    width: 180px;
    height: 180px;
  }
`;

const Hint = styled.p`
  font-size: 12px;
  color: rgba(255,255,255,0.4);
  margin-bottom: 24px;
`;

const CopyButton = styled.button`
  width: 100%;
  background: linear-gradient(135deg, #5f259f, #7c3aed);
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 14px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(95,37,159,0.45); }
  &:active { transform: translateY(0); }
`;

const SuccessMsg = styled.div`
  background: rgba(34,197,94,0.15);
  border: 1px solid rgba(34,197,94,0.3);
  color: #86efac;
  font-size: 13px;
  padding: 10px 16px;
  border-radius: 10px;
  margin-bottom: 12px;
`;

const FooterNote = styled.p`
  font-size: 11px;
  color: rgba(255,255,255,0.25);
  margin-top: 16px;
  line-height: 1.6;
`;

const InternshipEnroll = () => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    });
  };

  return (
    <Page>
      <Card>
        <Logo>
          <h1>Willovate</h1>
          <p>Innovate with Heart. Build with Purpose.</p>
        </Logo>

        <Title>Internship Fee Payment</Title>
        <Sub>Scan the QR below using PhonePe, GPay or any UPI app</Sub>

        <FeeBox>
          <FeeLabel>Internship Onboarding Fee</FeeLabel>
          <FeeAmount>₹1,000</FeeAmount>
        </FeeBox>

        <QRWrapper>
          <QRImage src={qrCode} alt="PhonePe QR Code" />
        </QRWrapper>

        <Hint>After payment, share the screenshot with your coordinator.</Hint>

        {copied && <SuccessMsg>✅ Link copied!</SuccessMsg>}
        <CopyButton onClick={handleCopy}>🔗 Copy Link to Share</CopyButton>

        <FooterNote>
          Direct link only — not listed publicly.<br />
          admin@willovate.in &nbsp;|&nbsp; +91 93223 46482
        </FooterNote>
      </Card>
    </Page>
  );
};

export default InternshipEnroll;
